<template>
    <div class="content-table">
        <el-table :data="tableData" style="width: 100%;" row-key="id" default-expand-all stripe empty-text=" "
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
            <el-table-column prop="name" :label="$t('operation.rule.rule')"></el-table-column>
            <el-table-column prop="checkType" :label="$t('operation.rule.eventType')">
                <template slot-scope="scope">
                    <span v-if="scope.row.level === 4">
                        <img src="../../../../assets/icon/negative.png" class="check-image"
                            v-if="scope.row.checkType === 1" />
                        <img src="../../../../assets/icon/front.png" class="check-image"
                            v-if="scope.row.checkType === 2" />
                        {{ checkTypeFilter(scope.row.checkType) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="severity" :label="$t('operation.rule.scale')">

                <template slot-scope="scope">
                    <span v-if="scope.row.level === 4">
                        {{ scope.row.severity }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="standard" :label="$t('operation.rule.clientRequirement')" width="200"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column :label="$t('common.action')" width="300" v-if="acitonType !== 1">

                <template slot-scope="scope">
                    <span v-if="scope.row.level < 3 && !scope.row.clicked" class="blue-txt txt"
                        @click.stop.prevent="clickAdd(scope.row, 1)">{{ $t('operation.rule.addChild') }}</span>
                    <span v-if="scope.row.level === 3 && !scope.row.clicked" class="blue-txt txt"
                        @click.stop.prevent="clickAdd(scope.row, 2)">{{ $t('operation.rule.addEvent') }}</span>
                    <span v-if="scope.row.level !== 1" class="blue-txt txt" @click="clickEdit(scope.row)">{{
            $t('common.edit') }}</span>
                    <span v-if="scope.row.level !== 1" class="blue-txt txt" @click="clickUp(scope.row)">{{
            $t('operation.rule.up') }}</span>
                    <span v-if="scope.row.level !== 1" class="blue-txt txt" @click="clickDown(scope.row)">{{
            $t('operation.rule.down') }}</span>
                    <span class="error-txt" v-if="scope.row.level !== 1" @click.stop.prevent="clickDelete(scope.row)">{{
            $t('common.delete') }}</span>
                </template>

            </el-table-column>
        </el-table>
        <AddChildModal ref="addChildModalRef" @closeAddModal="closeChildModal"></AddChildModal>
        <AddEventModal ref="addEventModalRef" @closeAddModal="closeEventModal" :typeList="typeList"></AddEventModal>
    </div>
</template>

<script>
import AddChildModal from './addChildModal.vue'
import AddEventModal from './addEventModal.vue'
import Cookies from 'js-cookie'
export default {
    props: {
        acitonType: {
            type: Number,
            default() {
                return 0
            }
        },
    },
    components: {
        AddChildModal,
        AddEventModal
    },
    data() {
        return {
            monitorId: Number(Cookies.get("monitorId")),
            tableData: [],
            typeList: [
                { id: 1, name: vm.$t('operation.rule.negative') },
                { id: 2, name: vm.$t('operation.rule.positive') },
            ],
            parents: 0,
            currentDataRow: {},
        }
    },
    created() {
        let id = this.$route.params.id;
        if (id) {
            this.$Http.get(`${this.$Api.templateNodes}/${this.monitorId}/${id}`).then(res => {
                if (res.success) {
                    this.tableData = [res.result];
                }
            });
        } else {
            this.tableData = [{
                children: [], id: "1_1", level: 1, name: "Rule Template Name", pId: null
            }];
        }
    },
    methods: {
        updateTemplateName(name) {
            if (name) {
                if (this.tableData.length > 0) this.tableData[0].name = name;
            } else {
                if (this.tableData.length > 0) this.tableData[0].name = 'Rule Template Name';
            }
        },
        getRandomInt(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },
        // type  0:add 1:update
        updateChildTableData(type, data, arr) {
            for (var i = 0; i < arr.length; i++) {
                if (this.currentDataRow.pId === arr[i].pId && this.currentDataRow.id === arr[i].id) {
                    if (type === 1) {
                        arr[i].name = data.name;
                    } else {
                        let newData = Object.assign({}, data);
                        newData.pId = this.currentDataRow.id;
                        newData.level = this.currentDataRow.level + 1;
                        newData.children = [];
                        newData.id = Date.now() + '_' + this.getRandomInt(1, 1000);
                        arr[i].children.push(newData);
                    }
                    return false;
                }
                if (arr[i].children && arr[i].children.length > 0) {
                    this.updateChildTableData(type, data, arr[i].children)
                }
            }
        },
        // type  0:add 1:update
        updateEventTableData(type, data, arr) {
            for (var i = 0; i < arr.length; i++) {
                if (this.currentDataRow.pId === arr[i].pId && this.currentDataRow.id === arr[i].id) {
                    if (type === 1) {
                        arr[i].name = data.name;
                        arr[i].checkType = data.checkType;
                        arr[i].severity = data.severity;
                        arr[i].standard = data.standard;
                    } else {
                        let newData = Object.assign({}, data);
                        newData.pId = this.currentDataRow.id;
                        newData.level = this.currentDataRow.level + 1;
                        newData.children = [];
                        newData.id = Date.now() + '_' + this.getRandomInt(1, 1000);
                        arr[i].children.push(newData);
                    }
                    return false;
                }
                if (arr[i].children && arr[i].children.length > 0) {
                    this.updateEventTableData(type, data, arr[i].children)
                }
            }
        },
        closeChildModal(type, data) {
            let list = JSON.parse(JSON.stringify(this.tableData));
            this.updateChildTableData(type, data, list)
            this.tableData = list;
            this.$refs.addChildModalRef.close();
        },
        closeEventModal(type, data) {
            let list = JSON.parse(JSON.stringify(this.tableData));
            this.updateEventTableData(type, data, list)
            this.tableData = list;
            this.$refs.addEventModalRef.close();
        },
        checkTypeFilter(type) {
            let data = this.typeList.filter(item => {
                return item.id === type
            });
            return data.length > 0 ? data[0].name : ''
        },
        clickAdd(row, type) {
            this.currentDataRow = row;
            if (type === 1) {
                this.$refs.addChildModalRef.open(0);
            } else {
                this.$refs.addEventModalRef.open(0);
            }
        },
        clickEdit(row) {
            this.currentDataRow = row;
            if (row.level <= 3) {
                this.$refs.addChildModalRef.open(1, row);
            } else {
                this.$refs.addEventModalRef.open(1, row);
            }
        },
        clickUp(row) {
            this.moveTableData('up', row.pId, row.id, this.tableData)
        },
        clickDown(row) {
            this.moveTableData('down', row.pId, row.id, this.tableData)
        },
        moveTableData(type, pid, id, arr) {
            for (var i = 0; i < arr.length; i++) {
                if (pid === arr[i].id) {
                    let index = -1;
                    arr[i].children.forEach((item, i) => {
                        if (item.id === id) {
                            index = i;
                        }
                    });
                    if (type === 'up') {
                        if (index !== 0) {
                            arr[i].children.splice(index - 1, 0, (arr[i].children[index]))
                            arr[i].children.splice(index + 1, 1)
                        }
                    } else {
                        if (index !== arr[i].children - 1) {
                            arr[i].children.splice(index + 2, 0, (arr[i].children[index]))
                            arr[i].children.splice(index, 1)
                        }
                    }
                    return false;
                }
                if (arr[i].children && arr[i].children.length > 0) {
                    this.moveTableData(type, pid, id, arr[i].children)
                }
            }
        },
        deleteTableData(pid, id, arr) {
            for (var i = 0; i < arr.length; i++) {
                if (pid === arr[i].id) {
                    let index = -1;
                    arr[i].children.forEach((item, i) => {
                        if (item.id === id) {
                            index = i;
                        }
                    });
                    arr[i].children.splice(index, 1);
                    return false;
                }
                if (arr[i].children && arr[i].children.length > 0) {
                    this.deleteTableData(pid, id, arr[i].children)
                }
            }
        },
        clickDelete(row) {
            this.deleteTableData(row.pId, row.id, this.tableData);
        },
    }
}

</script>

<style scoped lang="scss">
.content-table {
    .check-image {
        width: 16px;
        height: 16px;
        vertical-align: middle;
        margin-right: 5px;
    }

    .txt {
        margin-right: 16px;
        color: $theme-color;
        cursor: pointer;
    }

    .txt-add {
        display: inline-block;
    }
}
</style>